import React from 'react'
import {
  ContactsOutlined,
  UsergroupDeleteOutlined,
  ControlOutlined,
  KeyOutlined,
  AreaChartOutlined,
  AuditOutlined,
  WhatsAppOutlined,
  UserOutlined,
  LockOutlined,
  DeploymentUnitOutlined,
  AppstoreOutlined,
  ProfileOutlined,
  LineChartOutlined,
  SettingOutlined,
  NotificationOutlined,
  BookOutlined,
  CreditCardOutlined,
  ProjectOutlined,
  DollarOutlined,
  PicLeftOutlined,
  CompassOutlined,
  MailOutlined
} from '@ant-design/icons'
import { wrap } from 'lodash'
import { getLanguage } from './utils/user-func'

export const USER_SESSION_KEY = 'goong_user_client'
export const MONEY_TO_VNP = 'money_to_vnpay'

export const CHART_TYPE = {
  CALL_API: {
    text: 'Api Request Total',
    title: 'APIs'
  },
  LOAD_MAP: {
    text: 'Map Load Total',
    title: 'MAP'
  },
  GEOCODE: {
    text: 'Geocode',
    title: ''
  },
  FORWARD_GEOCODE: {
    text: 'Forward geocode',
    title: ''
  },
  REVERSE_GEOCODE: {
    text: 'Reverse geocode',
    title: ''
  },
  DIRECTION: {
    text: 'Directions',
    title: ''
  },
  DISTANCE_MATRIX: {
    text: 'Distance matrix',
    title: ''
  },
  PLACE_DETAIL: {
    text: 'Place detail',
    title: ''
  },
  AUTOCOMPLETE: {
    text: 'Autocomplete',
    title: ''
  },
  FIND_PLACE_FROM_TEXT: {
    text: 'Find Place_from_text',
    title: ''
  },
  SESSION_AUTOCOMPLETE: {
    text: 'Session autocomplete',
    title: ''
  },
  GEO_LOCATION: {
    text: 'Geo Location',
    title: ''
  },
  SPEED_LIMIT: {
    text: 'Speed Limit',
    title: ''
  },
  STATIC_MAP: {
    text: 'Static Map',
    title: ''
  },
  TRIP: {
    text: 'Trip',
    title: ''
  }
}

export const ITEM_DATASET_DEFAULT = {
  label: '',
  data: [],
  fill: false,
  lineTension: 0.4,
  backgroundColor: '#3A93F9',
  borderColor: '#3A93F9',
  borderCapStyle: 'butt',
  borderDash: [],
  borderDashOffset: 0.0,
  borderJoinStyle: 'miter',
  pointBorderColor: '#3A93F9',
  pointBackgroundColor: '#fff',
  pointBorderWidth: 1,
  pointHoverRadius: 5,
  pointHoverBackgroundColor: '#3A93F9',
  pointHoverBorderColor: '#3A93F9',
  pointHoverBorderWidth: 2,
  pointRadius: 1,
  pointHitRadius: 10
  // xAxisID: 0,
  // yAxisID: 0,
}

export const PIE_OPTIONS = {
  legend: {
    display: true,
    position: 'left',
    labels: {
      generateLabels: function (chart) {
        var labels = chart?.data?.labels
        var data = chart?.data?.datasets[0]
        return labels.map((item, i) => {
          return {
            text: item + ': ' + data?.data[i]?.toLocaleString(getLanguage()),
            fillStyle: data?.backgroundColor[i],
            lineWidth: data?.borderWidth
          }
        })
      },
      fontSize: 18,
      fontColor: 'black'
    }
  },
  plugins: {
    labels: [
      {
        render: function (args) {
          if (args.percentage > 10) {
            return `${args.label}\n${args.percentage?.toLocaleString(getLanguage())}%`
          }
        },

        fontColor: 'white',
        fontSize: 14,
        precision: 2
      }
    ]
  },
  maintainAspectRatio: false
}

export const ITEM_PIE_DATASET_DEFAULT = {
  labels: [],
  datasets: [
    {
      data: [],
      backgroundColor: [
        'rgb(54, 162, 235)',
        'rgb(255, 206, 86)',
        'rgb(75, 192, 192)',
        'rgb(153, 102, 255)',
        'rgb(255, 109, 64)',
        'rgb(145, 59, 10)',
        'red',
        'green',
        'blue',
        'purple',
        '#ff3333',
        '#3366ff',
        '#33cc33',
        '#cc0066',
        '#336699',
        '#ff99ff',
        'orange',
        'green',
        '#ff0055',
        '#009933',
        '#0033cc',
        '#3366cc'
      ],
      borderWidth: 0,
      datalabels: {
        color: 'blue',
        labels: {
          title: {
            font: {
              weight: 'bold'
            }
          },
          value: {
            color: 'green'
          }
        }
      }
    }
  ]
}

export const ITEM_DATASET_PIE = {
  label: [],
  data: [],
  fill: false,
  backgroundColor: [
    'rgb(54, 162, 235)',
    'rgb(255, 206, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(255, 109, 64)',
    'rgb(145, 59, 10)',
    'red',
    'green',
    'blue',
    'purple',
    '#ff3333',
    '#ff3333',
    '#3366ff',
    '#33cc33',
    '#cc0066',
    '#336699',
    '#ff99ff',
    'orange',
    'green',
    '#ff0055',
    '#009933',
    '#0033cc',
    '#3366cc'
  ],
  borderWidth: 0
}

export const TOKEN_ORIGIN_LIST = ['https://editor.goong.io', 'http://localhost:8888']

export const SIDE_BAR_ADMIN = [
  {
    type: 'OVERVIEW',
    path: '/administrator/overview',
    activeWith: ['/administrator', '/administrator/overview'],
    title: 'Over View',
    allow: ['admin'],
    icon: function () {
      return (
        <svg width={18} height={19} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <mask id="path-1-inside-1" fill="white">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.984 0.600006H18V6.60001H9.984V0.600006ZM9.984 18.6V8.61601H18V18.6H9.984ZM0 18.6V12.6H8.016V18.6H0ZM0 10.584V0.600006H8.016V10.584H0Z"
              />
            </mask>
            <path
              d="M9.984 0.600006V-0.799994H8.584V0.600006H9.984ZM18 0.600006H19.4V-0.799994H18V0.600006ZM18 6.60001V8.00001H19.4V6.60001H18ZM9.984 6.60001H8.584V8.00001H9.984V6.60001ZM9.984 18.6H8.584V20H9.984V18.6ZM9.984 8.61601V7.21601H8.584V8.61601H9.984ZM18 8.61601H19.4V7.21601H18V8.61601ZM18 18.6V20H19.4V18.6H18ZM0 18.6H-1.4V20H0V18.6ZM0 12.6V11.2H-1.4V12.6H0ZM8.016 12.6H9.416V11.2H8.016V12.6ZM8.016 18.6V20H9.416V18.6H8.016ZM0 10.584H-1.4V11.984H0V10.584ZM0 0.600006V-0.799994H-1.4V0.600006H0ZM8.016 0.600006H9.416V-0.799994H8.016V0.600006ZM8.016 10.584V11.984H9.416V10.584H8.016ZM9.984 2.00001H18V-0.799994H9.984V2.00001ZM16.6 0.600006V6.60001H19.4V0.600006H16.6ZM18 5.20001H9.984V8.00001H18V5.20001ZM11.384 6.60001V0.600006H8.584V6.60001H11.384ZM11.384 18.6V8.61601H8.584V18.6H11.384ZM9.984 10.016H18V7.21601H9.984V10.016ZM16.6 8.61601V18.6H19.4V8.61601H16.6ZM18 17.2H9.984V20H18V17.2ZM1.4 18.6V12.6H-1.4V18.6H1.4ZM0 14H8.016V11.2H0V14ZM6.616 12.6V18.6H9.416V12.6H6.616ZM8.016 17.2H0V20H8.016V17.2ZM1.4 10.584V0.600006H-1.4V10.584H1.4ZM0 2.00001H8.016V-0.799994H0V2.00001ZM6.616 0.600006V10.584H9.416V0.600006H6.616ZM8.016 9.18401H0V11.984H8.016V9.18401Z"
              fill="#566571"
              mask="url(#path-1-inside-1)"
            />
          </g>
        </svg>
      )
    },
    iconSideBar: <AppstoreOutlined />
  },
  {
    type: 'SALES_MANAGEMENT',
    path: '/administrator/sales-account-management',
    activeWith: ['/administrator/sales-account-management'],
    title: 'Sales Acc Management',
    allow: ['admin'],
    icon: function () {
      return (
        <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <mask id="path-1-inside-1" fill="white">
              <path d="M11.0001 8.54546V11.8182L7.56372 14.3545" />
            </mask>
            <path
              d="M11.0001 11.8182L11.8315 12.9446L12.4001 12.5249V11.8182H11.0001ZM9.60008 8.54546V11.8182H12.4001V8.54546H9.60008ZM10.1687 10.6918L6.73233 13.2281L8.39511 15.481L11.8315 12.9446L10.1687 10.6918Z"
              fill="#566571"
              mask="url(#path-1-inside-1)"
            />
            <mask id="path-3-inside-2" fill="white">
              <path d="M11 11.8182L14.4364 14.3545L11 11.8182Z" />
            </mask>
            <path
              d="M10.1686 12.9446L13.605 15.4809L15.2678 13.2281L11.8314 10.6918L10.1686 12.9446Z"
              fill="#566571"
              mask="url(#path-3-inside-2)"
            />
            <path
              d="M11 9.24545C13.1941 9.24545 14.9727 7.4668 14.9727 5.27273C14.9727 3.07865 13.1941 1.3 11 1.3C8.80595 1.3 7.02729 3.07865 7.02729 5.27273C7.02729 7.4668 8.80595 9.24545 11 9.24545Z"
              stroke="#566571"
              strokeWidth="1.4"
            />
            <path
              d="M5.27273 20.7C7.4668 20.7 9.24545 18.9213 9.24545 16.7273C9.24545 14.5332 7.4668 12.7545 5.27273 12.7545C3.07865 12.7545 1.3 14.5332 1.3 16.7273C1.3 18.9213 3.07865 20.7 5.27273 20.7Z"
              stroke="#566571"
              strokeWidth="1.4"
            />
            <path
              d="M16.7273 20.7C18.9214 20.7 20.7 18.9213 20.7 16.7273C20.7 14.5332 18.9214 12.7545 16.7273 12.7545C14.5332 12.7545 12.7546 14.5332 12.7546 16.7273C12.7546 18.9213 14.5332 20.7 16.7273 20.7Z"
              stroke="#566571"
              strokeWidth="1.4"
            />
          </g>
        </svg>
      )
    },
    iconSideBar: <DeploymentUnitOutlined />
  },
  {
    type: 'USER_MANAGEMENT',
    path: '/administrator/user-management',
    activeWith: [
      '/administrator/user-management',
      '/administrator/user-management/create-user',
      '/administrator/user-management/edit-user',
      '/administrator/view-hits-per-user'
    ],
    title: 'Account Management',
    allow: ['admin', 'support'],
    icon: function () {
      return (
        <svg width={21} height={21} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <path
              d="M8.71429 11.8C6.29371 11.8 4.14657 12.3742 2.73571 12.8737C1.69429 13.2436 1 14.2741 1 15.4288V19C1 19 9.53543 19 9.57143 19"
              stroke="#566571"
              strokeWidth="1.4"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.71418 11.8V11.8C6.34761 11.8 4.42847 8.8849 4.42847 6.4V5.5C4.42847 3.0151 6.34761 1 8.71418 1V1C11.0808 1 12.9999 3.0151 12.9999 5.5V6.4C12.9999 8.8849 11.0808 11.8 8.71418 11.8Z"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="square"
            />
            <path
              d="M12.3333 13.3333H13.6666V18.6667H18.3333L19.6666 15.3333H13.6666"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.9999 21C14.3681 21 14.6666 20.7015 14.6666 20.3333C14.6666 19.9651 14.3681 19.6667 13.9999 19.6667C13.6317 19.6667 13.3333 19.9651 13.3333 20.3333C13.3333 20.7015 13.6317 21 13.9999 21Z"
              fill="#566571"
            />
            <path
              d="M18.6667 21C19.0349 21 19.3333 20.7015 19.3333 20.3333C19.3333 19.9651 19.0349 19.6667 18.6667 19.6667C18.2985 19.6667 18 19.9651 18 20.3333C18 20.7015 18.2985 21 18.6667 21Z"
              fill="#566571"
            />
          </g>
        </svg>
      )
    },
    iconSideBar: <UserOutlined />
  },
  {
    type: 'BILLING_MANAGEMENT',
    path: '/administrator/billing-management',
    activeWith: ['/administrator/billing-management'],
    title: 'Billing Manager',
    allow: ['admin'],
    icon: function () {
      return (
        <svg width={18} height={20} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.2858 1.5625H2.71439C2.08321 1.5625 1.57153 2.06618 1.57153 2.6875V18.4375L4.42868 16.1875L6.71439 18.4375L9.0001 16.1875L11.2858 18.4375L13.5715 16.1875L16.4287 18.4375V2.6875C16.4287 2.06618 15.917 1.5625 15.2858 1.5625Z"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 11.6875H8.42857"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 11.6875H11.8572"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 8.6875H8.42857"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 8.6875H11.8572"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 5.6875H8.42857"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 5.6875H11.8572"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      )
    },
    iconSideBar: <ProfileOutlined />
  },
  {
    type: 'USAGE_STATISTICS',
    path: '/administrator/usage-statistics',
    activeWith: ['/administrator/usage-statistics', '/administrator/usage-statistics-per-user'],
    title: 'Usage Statistics',
    allow: ['admin'],
    icon: function () {
      return (
        <svg width={18} height={20} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.2858 1.5625H2.71439C2.08321 1.5625 1.57153 2.06618 1.57153 2.6875V18.4375L4.42868 16.1875L6.71439 18.4375L9.0001 16.1875L11.2858 18.4375L13.5715 16.1875L16.4287 18.4375V2.6875C16.4287 2.06618 15.917 1.5625 15.2858 1.5625Z"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 11.6875H8.42857"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 11.6875H11.8572"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 8.6875H8.42857"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 8.6875H11.8572"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 5.6875H8.42857"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 5.6875H11.8572"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      )
    },
    iconSideBar: <LineChartOutlined />
  },
  {
    type: 'CAMPAIGNS',
    path: '/administrator/campaigns',
    activeWith: ['/administrator/campaigns'],
    title: 'Campaigns',
    allow: ['admin', 'support'],
    icon: function () {
      return (
        <svg width={18} height={19} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.6 8.82609V6.47826C14.6 3.4527 12.0928 1 9 1C5.90721 1 3.4 3.4527 3.4 6.47826V8.82609C3.4 11.4087 1 12.0348 1 13.5217C1 14.8522 4.12 15.8696 9 15.8696C13.88 15.8696 17 14.8522 17 13.5217C17 12.0348 14.6 11.4087 14.6 8.82609Z"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="square"
            />
            <path
              d="M9.00006 17.4348C8.19126 17.4348 7.43126 17.4082 6.71606 17.3565C7.029 18.333 7.95393 18.9976 9.00006 18.9976C10.0462 18.9976 10.9711 18.333 11.2841 17.3565C10.5689 17.4082 9.80886 17.4348 9.00006 17.4348Z"
              fill="#566571"
            />
          </g>
        </svg>
      )
    },
    iconSideBar: <PicLeftOutlined />
  },
  {
    type: 'CHANGE_EMAIL',
    path: '/administrator/change-email',
    activeWith: ['/administrator/change-email'],
    title: 'Change Email',
    allow: ['admin', 'support'],
    icon: function () {
      return (
        <svg width={18} height={19} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.6 8.82609V6.47826C14.6 3.4527 12.0928 1 9 1C5.90721 1 3.4 3.4527 3.4 6.47826V8.82609C3.4 11.4087 1 12.0348 1 13.5217C1 14.8522 4.12 15.8696 9 15.8696C13.88 15.8696 17 14.8522 17 13.5217C17 12.0348 14.6 11.4087 14.6 8.82609Z"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="square"
            />
            <path
              d="M9.00006 17.4348C8.19126 17.4348 7.43126 17.4082 6.71606 17.3565C7.029 18.333 7.95393 18.9976 9.00006 18.9976C10.0462 18.9976 10.9711 18.333 11.2841 17.3565C10.5689 17.4082 9.80886 17.4348 9.00006 17.4348Z"
              fill="#566571"
            />
          </g>
        </svg>
      )
    },
    iconSideBar: <MailOutlined />
  },
  {
    type: 'NOTIFICATIONS',
    path: '/administrator/notifications',
    activeWith: ['/administrator/notifications'],
    title: 'Notifications',
    allow: ['admin', 'support'],
    icon: function () {
      return (
        <svg width={18} height={19} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.5">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.6 8.82609V6.47826C14.6 3.4527 12.0928 1 9 1C5.90721 1 3.4 3.4527 3.4 6.47826V8.82609C3.4 11.4087 1 12.0348 1 13.5217C1 14.8522 4.12 15.8696 9 15.8696C13.88 15.8696 17 14.8522 17 13.5217C17 12.0348 14.6 11.4087 14.6 8.82609Z"
              stroke="#566571"
              strokeWidth="1.4"
              strokeLinecap="square"
            />
            <path
              d="M9.00006 17.4348C8.19126 17.4348 7.43126 17.4082 6.71606 17.3565C7.029 18.333 7.95393 18.9976 9.00006 18.9976C10.0462 18.9976 10.9711 18.333 11.2841 17.3565C10.5689 17.4082 9.80886 17.4348 9.00006 17.4348Z"
              fill="#566571"
            />
          </g>
        </svg>
      )
    },
    iconSideBar: <NotificationOutlined />
  },
  {
    type: 'SUPPORT',
    path: '/administrator/support',
    activeWith: ['/administrator/support'],
    title: 'Support',
    allow: ['admin', 'support'],
    icon: function () {
      return <UsergroupDeleteOutlined />
    },
    iconSideBar: <UsergroupDeleteOutlined />
  },
  {
    type: 'FAQS',
    path: '/administrator/faqs',
    activeWith: ['/administrator/faqs'],
    title: 'FAQs',
    allow: ['admin', 'support'],
    icon: function () {
      return <ContactsOutlined />
    },
    iconSideBar: <ContactsOutlined />
  },
  {
    type: 'Coupon Manager',
    path: '/administrator/coupons',
    activeWith: ['/administrator/coupons'],
    title: 'Coupon Manager',
    allow: ['admin'],
    icon: function () {
      return <BookOutlined />
    },
    iconSideBar: <CreditCardOutlined />
  },
  {
    type: 'Log',
    path: '/administrator/logs',
    activeWith: ['/administrator/logs'],
    title: 'Logs',
    allow: ['admin', 'support'],
    icon: function () {
      return <BookOutlined />
    },
    iconSideBar: <BookOutlined />
  },
  {
    type: 'Plans',
    path: '/administrator/plans',
    activeWith: ['/administrator/plans'],
    title: 'Plans',
    allow: ['admin', 'support'],
    icon: function () {
      return <ProjectOutlined />
    },
    iconSideBar: <ProjectOutlined />
  },
  {
    type: 'SETTINGS',
    path: '/administrator/settings',
    activeWith: ['/administrator/settings'],
    allow: ['admin'],
    title: 'Settings',
    icon: function () {
      return (
        <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.5"
            d="M17.875 8.16992L17.7249 8.85364L17.7399 8.85694L17.7551 8.85957L17.875 8.16992ZM16.4336 7.85352L15.7545 8.02329L15.8597 8.44421L16.2835 8.53724L16.4336 7.85352ZM16.0117 6.81641L15.41 6.45865L15.2146 6.78738L15.3856 7.12945L16.0117 6.81641ZM16.7852 5.51562L16.1982 5.13413L16.1906 5.14585L16.1835 5.15787L16.7852 5.51562ZM16.7852 3.91602L16.2902 4.41099L16.2902 4.41099L16.7852 3.91602ZM15.9941 3.125L15.4992 3.61997V3.61997L15.9941 3.125ZM14.3594 3.07227L14.7363 3.66217L14.7409 3.65918L14.3594 3.07227ZM13.0938 3.88086L12.7807 4.50696L13.1359 4.68458L13.4706 4.47075L13.0938 3.88086ZM12.0742 3.45898L11.3898 3.60565L11.4735 3.99662L11.8529 4.12306L12.0742 3.45898ZM11.7578 1.98242L12.4423 1.83574L12.4404 1.82729L11.7578 1.98242ZM11.3535 1.23535L10.8275 1.69721V1.69721L11.3535 1.23535ZM8.68164 1.23535L9.23346 1.66604L8.68164 1.23535ZM8.3125 2L8.99062 2.17366L8.9938 2.16124L8.99652 2.1487L8.3125 2ZM7.94336 3.44141L8.15215 4.10954L8.52465 3.99314L8.62148 3.61507L7.94336 3.44141ZM6.85352 3.89844L6.47822 4.48933L6.82277 4.70817L7.18293 4.51608L6.85352 3.89844ZM5.55273 3.07227L5.15746 3.64998L5.16733 3.65674L5.17744 3.66316L5.55273 3.07227ZM4.73535 2.81738L4.77348 2.11842L4.73535 2.81738ZM3.93555 3.125L4.42505 3.62538L4.43456 3.61608L4.44371 3.60642L3.93555 3.125ZM3.12695 3.91602L2.63745 3.41563L2.62794 3.42494L2.61879 3.43459L3.12695 3.91602ZM3.12695 5.51562L2.52671 5.87577L2.52739 5.8769L3.12695 5.51562ZM3.95312 6.88672L4.5887 7.18006L4.74417 6.84321L4.55269 6.52544L3.95312 6.88672ZM3.56641 7.85352L3.71649 8.53724L4.12467 8.44764L4.23947 8.04582L3.56641 7.85352ZM2.125 8.16992L2.24494 8.85957L2.26008 8.85694L2.27509 8.85364L2.125 8.16992ZM1.36035 8.56543L1.82933 9.0851L1.36035 8.56543ZM1.36035 11.2285L1.79104 10.6767L1.36035 11.2285ZM2.125 11.6152L1.94827 12.2927L1.96102 12.2958L2.125 11.6152ZM3.58398 11.9668L4.25705 11.7745L4.14489 11.3819L3.74797 11.2863L3.58398 11.9668ZM3.95312 12.8633L4.55269 13.2246L4.75145 12.8947L4.57922 12.5502L3.95312 12.8633ZM3.12695 14.2344L2.52739 13.8731L2.52671 13.8742L3.12695 14.2344ZM3.12695 15.834L2.61879 16.3154L2.62794 16.3251L2.63745 16.3344L3.12695 15.834ZM3.93555 16.625L4.44371 16.1436L4.43456 16.1339L4.42505 16.1246L3.93555 16.625ZM4.73535 16.9326L4.77348 17.6316L4.73535 16.9326ZM5.55273 16.6777L5.17744 16.0868L5.16733 16.0933L5.15745 16.1L5.55273 16.6777ZM6.85352 15.8516L7.18293 15.2339L6.82277 15.0418L6.47822 15.2607L6.85352 15.8516ZM7.96094 16.3086L8.641 16.1427L8.54727 15.7584L8.16973 15.6405L7.96094 16.3086ZM8.3125 17.75L7.63235 17.9159L7.63517 17.9267L8.3125 17.75ZM11.7578 17.75L11.0737 17.6016L11.0706 17.6158L11.0682 17.6301L11.7578 17.75ZM12.0742 16.291L11.8654 15.6229L11.4765 15.7444L11.3901 16.1427L12.0742 16.291ZM13.0938 15.8691L13.4706 15.2793L13.1359 15.0654L12.7807 15.243L13.0938 15.8691ZM14.3594 16.6777L14.7409 16.0908L14.7362 16.0878L14.3594 16.6777ZM16.7852 15.834L16.2902 15.339L16.2902 15.339L16.7852 15.834ZM16.7852 14.2344L16.1835 14.5921L16.1906 14.6041L16.1982 14.6159L16.7852 14.2344ZM16.0117 12.9336L15.3954 12.6017L15.2075 12.9507L15.41 13.2913L16.0117 12.9336ZM16.416 11.9668L16.252 11.2863L15.8747 11.3772L15.7519 11.7454L16.416 11.9668ZM17.875 11.6152L18.039 12.2959L18.0517 12.2926L17.875 11.6152ZM17.7551 8.85957C17.8724 8.87997 18.0103 8.94035 18.1707 9.08511L19.1086 8.04575C18.7886 7.75691 18.4167 7.55362 17.9949 7.48027L17.7551 8.85957ZM16.2835 8.53724L17.7249 8.85364L18.0251 7.4862L16.5837 7.16979L16.2835 8.53724ZM15.6103 7.60372C15.669 7.73466 15.7172 7.87425 15.7545 8.02329L17.1127 7.68374C17.0562 7.45778 16.9814 7.23995 16.8878 7.03104L15.6103 7.60372ZM15.3856 7.12945C15.4632 7.28457 15.5381 7.44266 15.6103 7.60372L16.8878 7.03104C16.8076 6.85226 16.7243 6.67636 16.6378 6.50336L15.3856 7.12945ZM16.1835 5.15787L15.41 6.45865L16.6134 7.17416L17.3868 5.87338L16.1835 5.15787ZM16.371 4.62679C16.347 4.83464 16.2861 4.999 16.1982 5.13413L17.3721 5.89712C17.5889 5.5635 17.7155 5.1888 17.7618 4.78727L16.371 4.62679ZM16.2902 4.41099C16.3664 4.48724 16.3809 4.54088 16.371 4.62679L17.7618 4.78727C17.8222 4.2638 17.6492 3.79011 17.2801 3.42104L16.2902 4.41099ZM15.4992 3.61997L16.2902 4.41099L17.2801 3.42104L16.4891 2.63003L15.4992 3.61997ZM15.2244 3.5163C15.3434 3.50969 15.4184 3.53917 15.4992 3.61997L16.4891 2.63003C16.1246 2.26552 15.6605 2.08992 15.1467 2.11846L15.2244 3.5163ZM14.7409 3.65918C14.8597 3.58196 15.0134 3.52803 15.2244 3.5163L15.1467 2.11846C14.7249 2.1419 14.3278 2.25789 13.9779 2.48536L14.7409 3.65918ZM13.4706 4.47075L14.7362 3.66215L13.9825 2.48238L12.7169 3.29097L13.4706 4.47075ZM12.3251 4.29916C12.4797 4.36312 12.6316 4.43239 12.7807 4.50696L13.4068 3.25476C13.2278 3.16527 13.0457 3.08219 12.8604 3.00553L12.3251 4.29916ZM11.8529 4.12306C12.0131 4.17649 12.1705 4.23519 12.3251 4.29916L12.8604 3.00553C12.6752 2.92887 12.4869 2.85867 12.2956 2.79491L11.8529 4.12306ZM11.0734 2.12909L11.3898 3.60565L12.7587 3.31231L12.4423 1.83575L11.0734 2.12909ZM10.8275 1.69721C10.9775 1.86805 11.0473 2.01492 11.0752 2.13756L12.4404 1.82729C12.3511 1.43429 12.1514 1.08313 11.8795 0.773491L10.8275 1.69721ZM10.5625 1.575C10.6751 1.575 10.7479 1.60653 10.8275 1.69721L11.8795 0.773491C11.5373 0.383699 11.0827 0.175 10.5625 0.175V1.575ZM9.4375 1.575H10.5625V0.175H9.4375V1.575ZM9.23346 1.66604C9.28251 1.6032 9.32709 1.575 9.4375 1.575V0.175C8.9151 0.175 8.45577 0.387035 8.12982 0.804662L9.23346 1.66604ZM8.99652 2.1487C9.03053 1.99227 9.10378 1.83219 9.23346 1.66604L8.12982 0.804662C7.88449 1.11898 7.71166 1.46867 7.62848 1.8513L8.99652 2.1487ZM8.62148 3.61507L8.99062 2.17366L7.63438 1.82634L7.26524 3.26774L8.62148 3.61507ZM7.66036 4.28909C7.82178 4.2214 7.98569 4.16156 8.15215 4.10954L7.73457 2.77327C7.52603 2.83844 7.3208 2.91337 7.11894 2.99802L7.66036 4.28909ZM7.18293 4.51608C7.3398 4.43242 7.49893 4.35679 7.66036 4.28909L7.11894 2.99802C6.91708 3.08267 6.71879 3.17696 6.5241 3.28079L7.18293 4.51608ZM5.17744 3.66316L6.47822 4.48933L7.22881 3.30755L5.92803 2.48137L5.17744 3.66316ZM4.69723 3.51634C4.91686 3.52832 5.05961 3.58304 5.15746 3.64998L5.94801 2.49455C5.60054 2.25681 5.19838 2.1416 4.77348 2.11842L4.69723 3.51634ZM4.44371 3.60642C4.50508 3.54164 4.5679 3.50929 4.69723 3.51634L4.77348 2.11842C4.25827 2.09032 3.78789 2.26304 3.42738 2.64358L4.44371 3.60642ZM3.61646 4.4164L4.42505 3.62538L3.44604 2.62462L2.63745 3.41563L3.61646 4.4164ZM3.55867 4.62679C3.54725 4.5278 3.56659 4.46978 3.63512 4.39744L2.61879 3.43459C2.26544 3.80757 2.109 4.27688 2.16789 4.78727L3.55867 4.62679ZM3.7272 5.15548C3.64378 5.01646 3.5838 4.8446 3.55867 4.62679L2.16789 4.78727C2.21308 5.17884 2.32887 5.54604 2.52671 5.87577L3.7272 5.15548ZM4.55269 6.52544L3.72652 5.15435L2.52739 5.8769L3.35356 7.248L4.55269 6.52544ZM4.38559 7.63707C4.45353 7.47854 4.52124 7.32622 4.5887 7.18006L3.31755 6.59338C3.24439 6.75191 3.17147 6.91599 3.09879 7.08559L4.38559 7.63707ZM4.23947 8.04582C4.27787 7.91144 4.32638 7.77522 4.38559 7.63707L3.09879 7.08559C3.01737 7.27557 2.9487 7.46747 2.89334 7.66121L4.23947 8.04582ZM2.27509 8.85364L3.71649 8.53724L3.41632 7.16979L1.97491 7.4862L2.27509 8.85364ZM1.82933 9.0851C1.98973 8.94035 2.12761 8.87997 2.24494 8.85957L2.00506 7.48027C1.58332 7.55362 1.21145 7.75691 0.891377 8.04575L1.82933 9.0851ZM1.7 9.36523C1.7 9.25201 1.73236 9.17261 1.82933 9.0851L0.891377 8.04575C0.507871 8.39184 0.3 8.84564 0.3 9.36523H1.7ZM1.7 10.4902V9.36523H0.3V10.4902H1.7ZM1.79104 10.6767C1.72073 10.6218 1.7 10.5793 1.7 10.4902H0.3C0.3 11.0106 0.519504 11.4602 0.929662 11.7803L1.79104 10.6767ZM2.30169 10.9379C2.13286 10.8939 1.96318 10.811 1.79104 10.6767L0.929662 11.7803C1.23799 12.021 1.57807 12.196 1.94831 12.2926L2.30169 10.9379ZM3.74797 11.2863L2.28898 10.9347L1.96102 12.2958L3.42 12.6473L3.74797 11.2863ZM4.3917 12.1507C4.34086 12.0352 4.29576 11.91 4.25705 11.7745L2.91092 12.1591C2.96596 12.3517 3.03219 12.5371 3.11026 12.7145L4.3917 12.1507ZM4.57922 12.5502C4.51413 12.42 4.45161 12.2869 4.3917 12.1507L3.11026 12.7145C3.17925 12.8713 3.25149 13.0253 3.32703 13.1763L4.57922 12.5502ZM3.72652 14.5957L4.55269 13.2246L3.35356 12.502L2.52739 13.8731L3.72652 14.5957ZM3.55867 15.1232C3.5838 14.9054 3.64378 14.7335 3.7272 14.5945L2.52671 13.8742C2.32887 14.204 2.21308 14.5712 2.16789 14.9627L3.55867 15.1232ZM3.63512 15.3526C3.56659 15.2802 3.54725 15.2222 3.55867 15.1232L2.16789 14.9627C2.109 15.4731 2.26544 15.9424 2.61879 16.3154L3.63512 15.3526ZM4.42505 16.1246L3.61646 15.3336L2.63745 16.3344L3.44604 17.1254L4.42505 16.1246ZM4.69723 16.2337C4.5679 16.2407 4.50508 16.2084 4.44371 16.1436L3.42738 17.1064C3.78789 17.487 4.25827 17.6597 4.77348 17.6316L4.69723 16.2337ZM5.15745 16.1C5.05961 16.167 4.91686 16.2217 4.69723 16.2337L4.77348 17.6316C5.19838 17.6084 5.60054 17.4932 5.94801 17.2554L5.15745 16.1ZM6.47822 15.2607L5.17744 16.0868L5.92803 17.2686L7.22881 16.4425L6.47822 15.2607ZM7.6619 15.4579C7.49655 15.3907 7.33694 15.3161 7.18293 15.2339L6.52411 16.4692C6.72165 16.5746 6.92532 16.6698 7.13497 16.755L7.6619 15.4579ZM8.16973 15.6405C8.00126 15.5878 7.832 15.527 7.6619 15.4579L7.13497 16.755C7.33988 16.8382 7.54561 16.9122 7.75215 16.9767L8.16973 15.6405ZM8.99256 17.5841L8.641 16.1427L7.28087 16.4745L7.63244 17.9159L8.99256 17.5841ZM9.25104 18.084C9.11669 17.9118 9.03388 17.7421 8.98983 17.5733L7.63517 17.9267C7.73175 18.2969 7.90675 18.637 8.1474 18.9453L9.25104 18.084ZM9.4375 18.175C9.34846 18.175 9.30592 18.1543 9.25104 18.084L8.1474 18.9453C8.46752 19.3555 8.91717 19.575 9.4375 19.575V18.175ZM10.5625 18.175H9.4375V19.575H10.5625V18.175ZM10.8426 18.0457C10.7551 18.1426 10.6757 18.175 10.5625 18.175V19.575C11.0821 19.575 11.5359 19.3671 11.882 18.9836L10.8426 18.0457ZM11.0682 17.6301C11.0478 17.7474 10.9874 17.8853 10.8426 18.0457L11.882 18.9836C12.1708 18.6636 12.3741 18.2917 12.4475 17.8699L11.0682 17.6301ZM11.3901 16.1427L11.0737 17.6016L12.4419 17.8984L12.7583 16.4394L11.3901 16.1427ZM12.3258 15.4543C12.1857 15.5143 12.0324 15.5707 11.8654 15.6229L12.283 16.9592C12.491 16.8942 12.6893 16.8216 12.8773 16.7411L12.3258 15.4543ZM12.7807 15.243C12.6286 15.3191 12.4769 15.3895 12.3258 15.4543L12.8773 16.7411C13.0543 16.6652 13.2308 16.5832 13.4068 16.4952L12.7807 15.243ZM14.7362 16.0878L13.4706 15.2793L12.7169 16.459L13.9825 17.2676L14.7362 16.0878ZM15.2244 16.2337C15.0134 16.222 14.8597 16.168 14.7409 16.0908L13.9779 17.2646C14.3278 17.4921 14.7249 17.6081 15.1467 17.6315L15.2244 16.2337ZM15.4992 16.13C15.4184 16.2108 15.3434 16.2403 15.2244 16.2337L15.1467 17.6315C15.6605 17.6601 16.1246 17.4845 16.4891 17.12L15.4992 16.13ZM16.2902 15.339L15.4992 16.13L16.4891 17.12L17.2801 16.329L16.2902 15.339ZM16.371 15.1232C16.3809 15.2091 16.3664 15.2628 16.2902 15.339L17.2801 16.329C17.6492 15.9599 17.8222 15.4862 17.7618 14.9627L16.371 15.1232ZM16.1982 14.6159C16.2861 14.751 16.347 14.9154 16.371 15.1232L17.7618 14.9627C17.7155 14.5612 17.5889 14.1865 17.3721 13.8529L16.1982 14.6159ZM15.41 13.2913L16.1835 14.5921L17.3868 13.8766L16.6134 12.5758L15.41 13.2913ZM15.5832 12.2037C15.5283 12.3384 15.4657 12.4711 15.3954 12.6017L16.628 13.2655C16.7218 13.0914 16.8057 12.9135 16.8797 12.7319L15.5832 12.2037ZM15.7519 11.7454C15.6978 11.908 15.6414 12.0607 15.5832 12.2037L16.8797 12.7319C16.9504 12.5585 17.0171 12.3772 17.0801 12.1882L15.7519 11.7454ZM17.711 10.9347L16.252 11.2863L16.58 12.6473L18.039 12.2958L17.711 10.9347ZM18.209 10.6767C18.0368 10.811 17.8671 10.8939 17.6983 10.9379L18.0517 12.2926C18.4219 12.196 18.762 12.021 19.0703 11.7803L18.209 10.6767ZM18.3 10.4902C18.3 10.5793 18.2793 10.6218 18.209 10.6767L19.0703 11.7803C19.4805 11.4602 19.7 11.0106 19.7 10.4902H18.3ZM18.3 9.36523V10.4902H19.7V9.36523H18.3ZM18.1707 9.08511C18.2676 9.17261 18.3 9.25201 18.3 9.36523H19.7C19.7 8.84564 19.4921 8.39184 19.1086 8.04575L18.1707 9.08511ZM10 12.825C10.8069 12.825 11.5152 12.5314 12.0858 11.9608L11.0958 10.9708C10.7876 11.2791 10.4353 11.425 10 11.425V12.825ZM7.91421 11.9608C8.48484 12.5314 9.19312 12.825 10 12.825V11.425C9.56469 11.425 9.21243 11.2791 8.90415 10.9708L7.91421 11.9608ZM7.05 9.875C7.05 10.6819 7.34357 11.3902 7.91421 11.9608L8.90415 10.9708C8.59588 10.6626 8.45 10.3103 8.45 9.875H7.05ZM7.91421 7.78921C7.34357 8.35984 7.05 9.06812 7.05 9.875H8.45C8.45 9.43968 8.59588 9.08743 8.90415 8.77915L7.91421 7.78921ZM10 6.925C9.19312 6.925 8.48484 7.21857 7.91421 7.78921L8.90415 8.77915C9.21243 8.47088 9.56468 8.325 10 8.325V6.925ZM12.0858 7.78921C11.5152 7.21857 10.8069 6.925 10 6.925V8.325C10.4353 8.325 10.7876 8.47088 11.0958 8.77915L12.0858 7.78921ZM12.95 9.875C12.95 9.06812 12.6564 8.35984 12.0858 7.78921L11.0958 8.77915C11.4041 9.08743 11.55 9.43969 11.55 9.875H12.95ZM12.0858 11.9608C12.6564 11.3902 12.95 10.6819 12.95 9.875H11.55C11.55 10.3103 11.4041 10.6626 11.0958 10.9708L12.0858 11.9608Z"
            fill="#566571"
          />
        </svg>
      )
    },
    iconSideBar: <SettingOutlined />
  }
]
export const CHART_LINE_OPTION = {
  legend: {
    display: false
  },
  tooltips: {
    callbacks: {
      label: function (tooltipItem) {
        return tooltipItem.yLabel
      }
    }
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true
        }
      }
    ]
  },
  maintainAspectRatio: false
}
const toPascalCase = str => {
  let name = ''
  for (let i in str) {
    if (i == 0 || str[i - 1] == ' ') {
      name += str[i].toUpperCase()
    } else if (i > 10) {
      name += '...'
      return name
    } else {
      name += str[i].toLowerCase()
    }
  }
  return name
}

export const CHART_DOUGHNUT_OPTION = {
  legend: {
    display: true,
    position: 'left',
    // markerType: "circle",
    // usePointStyle: 'circle',
    // symbolHeight: 12,
    // symbolWidth: 12,
    // symbolRadius: 0,
    // squareSymbol: false,

    fontSize: 4,
    labels: {
      boxWidth: 10,
      // This more specific font property overrides the global property
      // fontColor: 'rgb(255, 99, 132)',
      generateLabels: function (chart) {
        var labels = chart?.data?.labels
        var data = chart?.data?.datasets[0]
        return labels.map((item, i) => {
          return {
            text:
              toPascalCase(item.replaceAll('_', ' ')) +
              ': ' +
              data?.data[i]?.toLocaleString(getLanguage()),
            fillStyle: data?.backgroundColor[i],
            lineWidth: data?.borderWidth
          }
        })
      },
      fontSize: 16,
      fontColor: '#566571',
      fontSize: 10
    }
  },
  maintainAspectRatio: false
}

export const CHART_PIE_OPTION = {
  legend: {
    display: true,
    position: 'left',
    labels: {
      generateLabels: function (chart) {
        var labels = chart?.data?.labels
        var data = chart?.data?.datasets[0]
        return labels.map((item, i) => {
          return {
            text: item + ': ' + data?.data[i]?.toLocaleString(getLanguage()),
            fillStyle: data?.backgroundColor[i],
            lineWidth: data?.borderWidth
          }
        })
      },
      fontSize: 16,
      fontColor: '#566571'
    }
  },
  plugins: {
    labels: [
      {
        render: function (args) {
          if (args.percentage > 10) {
            return `${args.label}\n${args.percentage?.toLocaleString(getLanguage())}%`
          }
        },

        fontColor: '#000',
        fontSize: 13,
        precision: 2
      }
    ]
  },
  maintainAspectRatio: false
}

export const CHART_DOUGHNUT_OPTION_MOBILE = {
  legend: {
    display: true,
    position: 'top',
    fontSize: 5,
    labels: {
      fontSize: 12
    }
  },
  maintainAspectRatio: false
}

export const FREE_REMAINING = 100

export const SIDE_BAR_MOBILE_LINK = [
  {
    text: 'Dashboard',
    path: '/dashboard',
    icon: <ControlOutlined />
  },
  {
    text: 'Keys',
    path: '/keys',
    icon: <KeyOutlined />
  },
  {
    text: 'My Map',
    path: '/maps',
    icon: <CompassOutlined />
  },
  {
    text: 'Statistics',
    path: '/statistics',
    icon: <AreaChartOutlined />
  },
  {
    text: 'Payment history',
    path: '/payment',
    icon: <DollarOutlined />
  },
  {
    text: 'Billing',
    path: '/billing',
    icon: <AuditOutlined />
  },
  {
    text: 'Support',
    path: '/support/request',
    icon: <WhatsAppOutlined />
  },
  {
    text: 'Profile',
    path: '/settings/profile',
    icon: <UserOutlined />
  },
  {
    text: 'Change password',
    path: '/settings/change-password',
    icon: <LockOutlined />
  },
  {
    text: 'Security',
    path: '/settings/sercurity',
    icon: <DeploymentUnitOutlined />
  }
]

export const KEY_TYPE = {
  API_KEY: 'rsapi',
  MAPTILES_KEY: 'tile-server'
}
